import { Component, Input } from '@angular/core'
import { HeliosError, removeError, RootState } from '@helios/state-management'
import { Store } from '@ngrx/store'
import { DisplayDateTimeSecondFormat, formatDate } from '@northfork/basics'
import _ from 'lodash-es'

@Component({
  selector: 'hs-error-details-card',
  templateUrl: './error-details-card.component.html',
  styleUrls: ['./error-details-card.component.scss'],
})
export class ErrorDetailsCardComponent {
  private _heliosError?: HeliosError
  get heliosError(): HeliosError | undefined {
    return this._heliosError
  }

  @Input() set heliosError(value: HeliosError | undefined) {
    this._heliosError = value

    if (this._heliosError === undefined) {
      return
    }

    this.timestamp = formatDate(
      this._heliosError.timestamp,
      DisplayDateTimeSecondFormat,
    ) as string
    this.message = this._heliosError.message

    for (const [key, v] of Object.entries({ ...value })) {
      this.truncatedHeliosError[key] = _.truncate(JSON.stringify(v), {
        length: 100,
      })
    }
  }

  timestamp?: string
  message?: string
  truncatedHeliosError: Record<string, string> = {}
  isExpanded = false

  constructor(private readonly store: Store<RootState>) {}

  onRemoveError() {
    const errorId = this._heliosError?.id
    if (errorId === undefined) {
      return
    }

    this.store.dispatch(removeError(errorId))
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded
  }

  async onCopy() {
    await window.navigator.clipboard.writeText(JSON.stringify(this.heliosError))
  }
}
